import { theme } from '../../theme'

export const successCheckbox = (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.5" width="24" height="24" rx="5" fill="black" />
    <path
      d="M10.4999 15.3242L16.9995 8.90039L18 9.88846L10.4999 17.3004L6 12.8534L6.99982 11.8653L10.4999 15.3242Z"
      fill={theme.colors.primary}
      stroke={theme.colors.primary}
      strokeWidth="0.5"
    />
  </svg>
)

export const warningCheckbox = (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.5" width="24" height="24" rx="5" fill="black" />
    <path
      d="M10.4999 15.3242L16.9995 8.90039L18 9.88846L10.4999 17.3004L6 12.8534L6.99982 11.8653L10.4999 15.3242Z"
      fill={theme.colors.warningPrimary}
      stroke={theme.colors.warningPrimary}
      strokeWidth="0.5"
    />
  </svg>
)

export const errorCheckbox = (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.5" width="24" height="24" rx="5" fill="black" />
    <path
      d="M7.70711 7.20711C7.31658 6.81658 6.68342 6.81658 6.29289 7.20711C5.90237 7.59763 5.90237 8.2308 6.29289 8.62132L10.5858 12.9142L6.29289 17.2071C5.90237 17.5976 5.90237 18.2308 6.29289 18.6213C6.68342 19.0118 7.31658 19.0118 7.70711 18.6213L12 14.3284L16.2929 18.6213C16.6834 19.0118 17.3166 19.0118 17.7071 18.6213C18.0976 18.2308 18.0976 17.5976 17.7071 17.2071L13.4142 12.9142L17.7071 8.62132C18.0976 8.2308 18.0976 7.59763 17.7071 7.20711C17.3166 6.81658 16.6834 6.81658 16.2929 7.20711L12 11.5L7.70711 7.20711Z"
      fill={theme.colors.dangerPrimary}
      stroke={theme.colors.dangerPrimary}
      strokeWidth="0.5"
    />
  </svg>
)
